import React, {Suspense, lazy} from "react";
import {Redirect, Switch, Route} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../_metronic/layout";
import * as SUPP_CONFIG from "./supplements/UI/UIHelpers";
import * as BLG_CAT_CONFIG from "./blogCategories/UI/UIHelpers";
import * as ADMINS_CONFIG from "./admins/UI/UIHelpers";
import * as USERS_CONFIG from "./users/UI/UIHelpers";
import * as USER_CONFIG from "./user/UI/UIHelpers";
import * as EQUIP_CONFIG from "./equipments/UI/UIHelpers";
import * as MUSCLES_CONFIG from "./muscles/UI/UIHelpers";
import * as EXERCISE_CONFIG from "./exercises/UI/UIHelpers";
import * as WORKOUT_CONFIG from "./workouts/UI/UIHelpers";
import * as PLAN_CONFIG from "./plans/UI/UIHelpers";
import * as NOTIFICATION_CONFIG from "./notifications/UI/UIHelpers";

import * as MUSIC_CONFIG from "./music/UI/UIHelpers";
import * as CHALLENGE_CONFIG from "./challenge/UI/UIHelpers";

const MeatsPage = lazy(() => import("./meats"));
const MeatsCategoriesPage = lazy(() => import("./pages/MeatsCategories"));
const Supplements = lazy(() => import("./supplements/index"));
const Equipments = lazy(() => import("./equipments/index"));
const Muscles = lazy(() => import("./muscles/index"));
const Exercises = lazy(() => import("./exercises/index"));
const Workouts = lazy(() => import("./workouts/index"));
const Plans = lazy(() => import("./plans/index"));
const Admins = lazy(() => import("./admins/index"));
const Blogs = lazy(() => import("./blogs/index"));
const BlogCategories = lazy(() => import("./blogCategories/index"));
const Notifications = lazy(() => import("./notifications/index"));
const Users = lazy(() => import("./users/index"));
const User = lazy(() => import("./user/index"));

const Music = lazy(() => import("./music/index"));
const Challenge = lazy(() => import("./challenge/index"));

export default function BasePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <Switch>
                {
                    <Redirect exact from="/" to="/meats"/>
                }
                <ContentRoute path="/meats" component={MeatsPage}/>
                <ContentRoute path="/meats-categories" component={MeatsCategoriesPage}/>
                <ContentRoute path={SUPP_CONFIG.ROUTE.prefix} component={Supplements}/>
                <ContentRoute path={"/blogs"} component={Blogs}/>
                <ContentRoute path={BLG_CAT_CONFIG.ROUTE_PREFIX} component={BlogCategories}/>
                <ContentRoute path={EQUIP_CONFIG.ROUTE_PREFIX} component={Equipments}/>
                <ContentRoute path={MUSCLES_CONFIG.ROUTE_PREFIX} component={Muscles}/>
                <ContentRoute path={MUSIC_CONFIG.ROUTE_PREFIX} component={Music}/>
                <ContentRoute path={EXERCISE_CONFIG.ROUTE_PREFIX} component={Exercises}/>
                <ContentRoute path={WORKOUT_CONFIG.ROUTE_PREFIX} component={Workouts}/>
                <ContentRoute path={CHALLENGE_CONFIG.ROUTE_PREFIX} component={Challenge}/>
                <ContentRoute path={PLAN_CONFIG.ROUTE_PREFIX} component={Plans}/>
                <ContentRoute path={ADMINS_CONFIG.ROUTE.prefix} component={Admins}/>
                <ContentRoute path={USERS_CONFIG.ROUTE.prefix} component={Users}/>
                <ContentRoute path={USER_CONFIG.ROUTE.prefix} component={User}/>
                <ContentRoute path={NOTIFICATION_CONFIG.ROUTE_PREFIX} component={Notifications}/>
            </Switch>
        </Suspense>
    );
}
